import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "View-Off--Streamline-Ultimate.svg",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "24",
  width: "24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("desc", null, "View Off Streamline Icon: https://streamlinehq.com", -1)
const _hoisted_3 = ["stroke"]
const _hoisted_4 = ["stroke"]
const _hoisted_5 = ["stroke"]
const _hoisted_6 = ["stroke"]
const _hoisted_7 = ["stroke"]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'viewStreamOffline',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#b7b7b7",
  },
  size: {
    type: Number as PropType<number>,
    default: 16,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M2.78 21 21.53 3",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5"
      }, null, 8, _hoisted_3),
      _createElementVNode("path", {
        d: "M9 19.05a9.91 9.91 0 0 0 3 0.45c4.1 0.07 8.26 -2.81 10.82 -5.64a1.65 1.65 0 0 0 0 -2.22 20.06 20.06 0 0 0 -3.07 -2.76",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5"
      }, null, 8, _hoisted_4),
      _createElementVNode("path", {
        d: "M17.09 7.27A11.31 11.31 0 0 0 12 6c-4 -0.07 -8.2 2.75 -10.82 5.64a1.65 1.65 0 0 0 0 2.22 20 20 0 0 0 4.93 4",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5"
      }, null, 8, _hoisted_5),
      _createElementVNode("path", {
        d: "M9 15.07a3.85 3.85 0 0 1 5.5 -5.28",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5"
      }, null, 8, _hoisted_6),
      _createElementVNode("path", {
        d: "M15.75 12.75h0A3.75 3.75 0 0 1 12 16.5",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5"
      }, null, 8, _hoisted_7)
    ])
  ]))
}
}

})